import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe, FiChevronDown } from "react-icons/fi";
import { LANGS } from "../../i18n";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.resolvedLanguage) || LANGS[0];

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className={`lang${open ? " open" : ""}`} ref={ref}>
      <button
        className="lang-btn"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Language"
      >
        <FiGlobe size={15} />
        {current.label}
        <FiChevronDown className="chev" />
      </button>
      <div className="lang-menu" role="listbox">
        {LANGS.map((l) => (
          <button
            key={l.code}
            className={`lang-item${l.code === current.code ? " active" : ""}`}
            onClick={() => pick(l.code)}
            role="option"
            aria-selected={l.code === current.code}
          >
            {l.name}
            <span className="code">{l.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
